/**
 * Wer angemeldet ist, im Cache der Oberfläche.
 *
 * Beim Wechsel des Benutzers (Anmelden, Abmelden) darf nichts vom vorigen im
 * Speicher bleiben. Aber **nicht** mit `queryClient.clear()`: das entfernt
 * auch den Eintrag `["me"]`, an dem `App` hängt. Der danach gesetzte neue
 * Eintrag ist ein anderes Objekt, der Beobachter sieht ihn nie — die Anmeldung
 * gelingt, und die Maske bleibt trotzdem stehen.
 */
import type { QueryClient } from "@tanstack/react-query";
import type { MeDto } from "./auth";

export const ME_KEY = ["me"] as const;

export function applySession(queryClient: QueryClient, me: MeDto, fresh: boolean): void {
  if (fresh) {
    // Alles außer „wer bin ich" verwerfen: Daten, Zähler, offene Anfragen.
    void queryClient.cancelQueries({ predicate: (q) => q.queryKey[0] !== ME_KEY[0] });
    queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== ME_KEY[0] });
  }
  queryClient.setQueryData(ME_KEY, me);
}
